import React from "react";
import { Row, Col } from "react-bootstrap";
import { FiCreditCard } from "react-icons/fi";

const BankAccountDetailsSection = ({ formData, handleChange }) => {
  return (
    <div className="bma-card">
      <div className="bma-card-body">
        <div className="d-flex align-items-center gap-2 mb-3">
          <div className="bma-icon-circle"><FiCreditCard /></div>
          <h2 className="bma-card-title">2. Bank Account Details</h2>
        </div>
        <Row className="g-3">
          <Col md={3}>
            <label className="bma-label">Account Holder Name <span className="req">*</span></label>
            <input type="text" name="account_holder_name" className="bma-input" placeholder="Enter account holder name" value={formData.account_holder_name} onChange={handleChange} required />
          </Col>
          <Col md={3}>
            <label className="bma-label">Account Number <span className="req">*</span></label>
            <input type="text" name="account_number" className="bma-input" placeholder="Enter account number" value={formData.account_number} onChange={handleChange} required />
          </Col>
          <Col md={3}>
            <label className="bma-label">Re-enter Account Number <span className="req">*</span></label>
            <input type="text" name="re_account_number" className="bma-input" placeholder="Re-enter account number" value={formData.re_account_number} onChange={handleChange} required />
          </Col>
          <Col md={3}>
            <label className="bma-label">Bank Name <span className="req">*</span></label>
            <input type="text" name="bank_name" className="bma-input" placeholder="Enter bank name" value={formData.bank_name} onChange={handleChange} required />
          </Col>

          <Col md={3}>
            <label className="bma-label">IFSC Code <span className="req">*</span></label>
            <input type="text" name="ifsc_code" className="bma-input" placeholder="Enter IFSC code" value={formData.ifsc_code} onChange={handleChange} required />
          </Col>
          <Col md={3}>
            <label className="bma-label">Branch Name</label>
            <input type="text" name="branch_name" className="bma-input" placeholder="Enter branch name" value={formData.branch_name} onChange={handleChange} />
          </Col>
          <Col md={3}>
            <label className="bma-label">Account Type</label>
            <div className="bma-radio-group">
              <label className="bma-radio-label">
                <input type="radio" name="account_type" value="Savings" checked={formData.account_type === "Savings"} onChange={handleChange} /> Savings
              </label>
              <label className="bma-radio-label">
                <input type="radio" name="account_type" value="Current" checked={formData.account_type === "Current"} onChange={handleChange} /> Current
              </label>
            </div>
          </Col>
          <Col md={3}>
            <label className="bma-label">UPI ID (Optional)</label>
            <input type="text" name="upi_id" className="bma-input" placeholder="Enter UPI ID" value={formData.upi_id} onChange={handleChange} />
          </Col>

          <Col md={3}>
            <label className="bma-label">MICR Code (Optional)</label>
            <input type="text" name="micr_code" className="bma-input" placeholder="Enter MICR code" value={formData.micr_code} onChange={handleChange} />
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default BankAccountDetailsSection;